<svg
  xmlns="http://www.w3.org/2000/svg"
  xml:space="preserve"
  viewBox="0 0 434.785 434.785"
>
  <path
    d="M116.887 76.96c-9.858 0-19.717-3.752-27.223-11.257-15.01-15.011-15.01-39.435 0-54.445 15.011-15.01 39.434-15.011 54.446 0 15.01 15.01 15.01 39.435 0 54.445-7.506 7.505-17.364 11.257-27.223 11.257zm0-56.97a18.44 18.44 0 0 0-13.081 5.41c-7.213 7.212-7.213 18.948 0 26.161 7.212 7.212 18.949 7.212 26.161 0 7.213-7.212 7.213-18.948 0-26.161a18.437 18.437 0 0 0-13.08-5.41z"
    fill="#f99c38"
  />
  <path
    d="M271.189 82.398c41.252 37.466 71.505 99.669 81.857 151.082 18.304 91.019-40.619 179.655-131.638 197.976a168.85 168.85 0 0 1-35.394 3.316c-10.296-.128-15.61-12.468-8.423-19.842 31.763-32.59 47.429-79.782 37.762-127.768-7.389-36.652-34.062-66.91-54.012-94.917L271.189 82.398z"
    fill="#f9e17a"
  />
  <path
    d="M282.256 149.687a9.986 9.986 0 0 1-8.281-4.383 219.442 219.442 0 0 0-11.13-15.006c-3.482-4.287-2.83-10.585 1.457-14.067 4.286-3.481 10.584-2.831 14.066 1.458a239.188 239.188 0 0 1 12.151 16.379c3.103 4.569 1.914 10.788-2.654 13.891a9.96 9.96 0 0 1-5.609 1.728zM327.116 285.057c-.205 0-.411-.006-.618-.019-5.512-.336-9.709-5.077-9.373-10.589a129.068 129.068 0 0 0-2.313-33.279c-4.461-22.159-13.417-46.87-25.219-69.58-2.547-4.9-.639-10.938 4.262-13.485 4.903-2.547 10.938-.638 13.484 4.262 12.642 24.326 22.259 50.911 27.08 74.857a149.074 149.074 0 0 1 2.669 38.44 10.001 10.001 0 0 1-9.972 9.393z"
    fill="#fff"
  />
  <path
    d="m218.663 16.584-123.68 123.67-10.069-10.069c-5.363-5.363-5.363-14.059 0-19.422L189.162 6.506c5.363-5.364 14.06-5.364 19.423 0l10.078 10.078zM268.121 85.465 163.864 189.713c-5.363 5.363-14.059 5.363-19.422 0l-37.549-37.549 55.97 14.74-14.74-55.97 55.97 14.75-14.74-55.97 55.96 14.74-14.74-55.96 37.548 37.548c5.364 5.364 5.364 14.06 0 19.423z"
    fill="#ef5252"
  />
  <path
    d="m230.573 28.494 14.74 55.96-55.96-14.74 14.74 55.97-55.97-14.75 14.74 55.97-55.97-14.74-11.91-11.91 123.68-123.67z"
    fill="#f99c38"
  />
</svg>
